import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

const ModalParagraph = ({ children, ...props }: Props) => (
  <p data-role="dialog-intro" {...props}>
    {children}
  </p>
);

export default ModalParagraph;
